import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useFileReaderText } from "../../../../hooks";
import { ViewArchiveInfoLoadingIcon } from "../../status";
import csv from 'papaparse';
import DataGrid from 'react-data-grid';
import { ViewChunkPlainText } from "../text";
import { nanoid } from 'nanoid';
import { ViewerControlButtonDownload, ViewerControlsBox } from "../../controls";
import { ViewerArchiveContainer, ViewerDocumentContainer, ViewerControlsContainer } from "../../container";
import "./view-csv.style.scss";
export const CsvCellFormatter = props => /*#__PURE__*/React.createElement(React.Fragment, null, props.row[props.column.key]);

// TODO implement onViewed callback
// TODO implement with xlsx lib, delete papaparse
export const ViewCsv = props => {
  const {
    file,
    delimiter = ',',
    frozen = 2,
    resizable = true,
    formatter,
    onViewed
  } = props;
  const [loading, setLoading] = React.useState(true);
  const [columns, setColumns] = React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [plain, setPlain] = React.useState(null);
  const {
    text
  } = useFileReaderText(file);
  React.useEffect(() => {
    if (text) {
      csv.parse(text, {
        delimiter,
        header: false,
        complete: results => {
          const csvRows = results.data;
          if (csvRows.length > 0) {
            const headerRow = csvRows.shift();
            const headerColumns = headerRow.map((item, i) => ({
              key: nanoid(),
              name: item,
              frozen: i < frozen,
              resizable,
              formatter: formatter !== null && formatter !== void 0 ? formatter : CsvCellFormatter
            }));
            const bodyRows = csvRows.map(row => {
              const result = {};
              headerColumns.forEach((column, i) => {
                result[column.key] = row[i];
              });
              return result;
            });
            setColumns(headerColumns);
            setRows(bodyRows);
          }
          setLoading(false);

          // console.log('CSV PARSED: ', results)
        },

        error: e => {
          console.error('[CSV parser] ', e); // TODO feedback ?
          // TODO if error let select in dropdown the delimiter between ',' ';' 'TAB' ??
          setPlain(text);
        }
      });
    }
  }, [text]);

  // TODO tools could change frozen columns, delimiter and reread etc ...
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ViewerArchiveContainer, {
    className: "view-csv-container"
  }, /*#__PURE__*/React.createElement(ViewerControlsContainer, {
    className: "view-csv-tools"
  }, /*#__PURE__*/React.createElement(ViewerControlsBox, null, /*#__PURE__*/React.createElement(ViewerControlButtonDownload, {
    archive: {
      file
    },
    name: file.name
  }))), /*#__PURE__*/React.createElement(ViewerDocumentContainer, {
    className: "view-csv-document"
  }, plain ? /*#__PURE__*/React.createElement(ViewChunkPlainText, {
    text: plain
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, loading ? /*#__PURE__*/React.createElement(ViewArchiveInfoLoadingIcon, {
    name: file.name
  }) : /*#__PURE__*/React.createElement(DataGrid, {
    enableVirtualization: true,
    columns: columns,
    rows: rows,
    rowHeight: 22,
    className: "view-csv-fill-grid rdg-light"
  })))));
};